import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 2C7.44772 2 7 2.44772 7 3V4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V18H5C4.44772 18 4 17.5523 4 17V3C4 2.44772 4.44772 2 5 2H8ZM8 6V18H16V6H8ZM10 8C9.44772 8 9 8.44772 9 9C9 9.55228 9.44772 10 10 10H14C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8H10ZM9 12C9 11.4477 9.44772 11 10 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H10C9.44772 13 9 12.5523 9 12ZM10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14H10Z"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]



export default /*#__PURE__*/_defineComponent({
  __name: 'receipt-icon',
  props: ["class", "color"],
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(props.class),
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_2, 2))
}
}

})